// src/services/db.js
// Todas as operações com o Firestore

import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  query,
  where,
  orderBy,
  serverTimestamp,
  writeBatch
} from "firebase/firestore";
import { db } from "./firebase";

// ─── CARTÕES ────────────────────────────────────────────────
export async function getCards(userId) {
  const q = query(
    collection(db, "cards"),
    where("userId", "==", userId),
    orderBy("createdAt", "asc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function addCard(userId, card) {
  return await addDoc(collection(db, "cards"), {
    ...card,
    userId,
    createdAt: serverTimestamp()
  });
}

export async function deleteCard(cardId) {
  await deleteDoc(doc(db, "cards", cardId));
}

// ─── LANÇAMENTOS ────────────────────────────────────────────
export async function getEntries(userId) {
  const q = query(
    collection(db, "entries"),
    where("userId", "==", userId),
    orderBy("date", "desc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function addEntry(userId, entry) {
  return await addDoc(collection(db, "entries"), {
    ...entry,
    userId,
    createdAt: serverTimestamp()
  });
}

export async function addEntries(userId, entriesArr) {
  const batch = writeBatch(db);
  entriesArr.forEach(entry => {
    const ref = doc(collection(db, "entries"));
    batch.set(ref, { ...entry, userId, createdAt: serverTimestamp() });
  });
  await batch.commit();
}

export async function deleteEntry(entryId) {
  await deleteDoc(doc(db, "entries", entryId));
}

export async function deleteEntriesByGroup(userId, groupId) {
  const q = query(
    collection(db, "entries"),
    where("userId", "==", userId),
    where("groupId", "==", groupId)
  );
  const snap = await getDocs(q);
  const batch = writeBatch(db);
  snap.docs.forEach(d => batch.delete(d.ref));
  await batch.commit();
}

export async function deleteEntriesByCard(userId, cardId) {
  const q = query(
    collection(db, "entries"),
    where("userId", "==", userId),
    where("cardId", "==", cardId)
  );
  const snap = await getDocs(q);
  const batch = writeBatch(db);
  snap.docs.forEach(d => batch.delete(d.ref));
  await batch.commit();
}
